import { ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './dialog.module.scss';

interface Props {
    children: ReactNode;
    onClose: () => void;
}

export function Modal({ children, onClose }: Props) {
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };

        window.addEventListener('keydown', onKey);
        document.body.style.overflow = 'hidden';

        return () => {
            window.removeEventListener('keydown', onKey);
            document.body.style.overflow = '';
        };
    }, [onClose]);

    return createPortal(
        <div className={styles.backdrop} onMouseDown={onClose}>
            <div className={styles.modal}>
                <div className={styles.modalContent} onMouseDown={(e) => e.stopPropagation()}>
                    {children}
                </div>
            </div>
        </div>,
        document.body,
    );
}